import React from 'react';
import { Wallet, Lock } from 'lucide-react';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { useWallet } from '../contexts/WalletContext';

const WalletRequired = ({ 
  children, 
  message = "You need to connect your wallet to do this.",
  showIcon = true,
  className = "",
  action = "action"
}) => {
  const { isConnected } = useWallet();

  if (isConnected) {
    return children;
  }

  return (
    <div className={`flex flex-col items-center justify-center p-8 text-center ${className}`}>
      <div className="bg-black/50 backdrop-blur-sm border border-white/20 rounded-2xl p-8 max-w-md mx-auto">
        {showIcon && (
          <div className="flex flex-col items-center mb-0">
            {/* Outsera Logo */}
            <div className="w-48 h-48 relative">
              <img 
                src="./images/Chrome logo no background.png" 
                alt="Outsera" 
                className="w-full h-full object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              {/* Fallback if no logo loads */}
              <div className="w-full h-full bg-gradient-to-br from-purple-600 to-blue-600 rounded-full flex items-center justify-center text-white font-bold text-2xl hidden">
                O
              </div>
            </div>
          </div>
        )}
        
        <div className="text-center mb-6">
          <h3 className="text-2xl font-bold text-white mb-2">
            Connect with Outsera
          </h3>
          <p className="text-sm text-white/60 mb-3">
            Connect your wallet to continue
          </p>
        </div>
        
        <p className="text-white/70 mb-6 leading-relaxed">
          {message}
        </p>
        
        <div className="space-y-3">
          <div className="flex justify-center">
            <WalletMultiButton 
              className="!bg-white !text-black hover:!bg-gray-100 !rounded-xl !font-semibold !px-8 !py-3 !text-sm !border-0 !shadow-lg !transition-all !duration-300"
            />
          </div>
          
          <p className="text-xs text-white/50">
            Connect your wallet to {action} on Outsera
          </p>
        </div>
      </div>
    </div>
  );
};

export default WalletRequired;
